import { Modal, Select } from "antd";
import * as XLSX from "xlsx";
import * as fileSaver from "file-saver";
import moment from "moment";

function uniqueValues(array, codeKey, nameKey, type, dropdownValue) {
  if (array != undefined && array != null && array != "") {
    var filteredList = array.filter((value, index, selfArray) => {
      return (
        index ===
        selfArray.findIndex(
          (eachValue) => eachValue[codeKey] === value[codeKey]
        ),
        value[codeKey] !== null &&
        value[codeKey] !== undefined &&
        value[codeKey] !== " "
      );
    });

    var data = filteredList.map((eachProperty, index) => {
      return type == "customer" ? (
        <Select.Option
          value={eachProperty[codeKey]}
          key={index + 1}
        >{`${eachProperty[codeKey]} - ${eachProperty[nameKey]}`}</Select.Option>
      ) : type == "number" ? (
        <Select.Option value={eachProperty[codeKey]} key={index + 1}>
          {eachProperty[codeKey]}
        </Select.Option>
      ) : (
        <Select.Option value={eachProperty[codeKey]} key={index + 1}>
          {eachProperty[nameKey]}
        </Select.Option>
      );
    });

    data.unshift(
      <Select.Option value={dropdownValue == "numberList" ? 0 : ""} key={0}>
        All
      </Select.Option>
    );
    return data;
  }
}

function advanceFilterUniqueValues(array = [], valueKey, displayKey, sorting) {
  var uniqueValueKey = {};

  var uniqueArray = array?.map((eachElement) => {
    if (eachElement[valueKey] && !uniqueValueKey[eachElement[valueKey]]) {
      uniqueValueKey[eachElement[valueKey]] = true;
      return (
        <Select.Option
          value={eachElement[valueKey]}
          key={eachElement[valueKey]}
        >
          {eachElement[displayKey]}
        </Select.Option>
      );
    }
  });

  if (sorting === "alphabeticallySort") {
    uniqueArray?.sort((a, b) => {
      return a.props.children.localeCompare(b.props.children);
    });
  } else if (sorting === "numericallySort") {
    uniqueArray?.sort((a, b) => {
      return a.props.children - b.props.children;
    });
  }

  return uniqueArray?.filter((result) => {
    return result !== undefined;
  });
}

function uniqueValuesWithoutOption(array = [], codeKey, nameKey, type) {
  var uniqueCodeKey = {};

  var data = array?.map((eachProperty) => {
    if (eachProperty && eachProperty[codeKey] && !uniqueCodeKey[eachProperty[codeKey]]) {
      uniqueCodeKey[eachProperty[codeKey]] = true;
      return (type === "concatenate" ?
        <Select.Option value={eachProperty[codeKey]} key={eachProperty[codeKey]}>
          {`${eachProperty[codeKey]} - ${eachProperty[nameKey]}`}
        </Select.Option>
        : <Select.Option value={eachProperty[codeKey]} key={eachProperty[codeKey]}>
          {eachProperty[nameKey]}
        </Select.Option>);
    };
  });
  return data?.filter((result) => result !== undefined);
};

function uniqueValuesWithoutAllOption(array = [], codeKey, nameKey, type) {
  var uniqueCodeKey = {};

  var data = array?.map((eachProperty) => {
    if (
      eachProperty &&
      eachProperty[codeKey] &&
      !uniqueCodeKey[eachProperty[codeKey]]
    ) {
      uniqueCodeKey[eachProperty[codeKey]] = true;
      return type == "concatenate" ? (
        <Select.Option
          value={eachProperty[codeKey]}
          key={eachProperty[codeKey]}
        >
          {`${eachProperty[nameKey]} - ${eachProperty[codeKey]}`}
        </Select.Option>
      ) : (
        <Select.Option
          value={eachProperty[codeKey]}
          key={eachProperty[codeKey]}
        >
          {eachProperty[nameKey]}
        </Select.Option>
      );
    }
  });
  return data.filter((result) => result !== undefined);
}

function validateDateFormat(value) {
  const isoDatePattern = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{1,6})?)?(Z|[\+\-]\d{2}:\d{2})?$/;
  if (!isoDatePattern.test(value)) {
    return false;
  };
  const date = new Date(value);
  return !isNaN(date.getTime());
};

function getDataType(value, key) {
  if (["amount", "future", "outstanding", "total"].some((eachWord) => (key.toLowerCase().includes(eachWord)))) {
    return 'amount';
  }
  if (["invoice_ref_no", "p_o_no"].some((eachWord) => (key.toLowerCase().includes(eachWord)))) {
    return 'string';
  } else if (key.includes('remarks')) {
    return typeof value;
  }
  else if (typeof value === 'string' && !isNaN(parseFloat(value)) && value.includes('.') && !validateDateFormat(value)) {
    return 'amount';
  }
  else if ((typeof value === 'string' && !isNaN(Date.parse(value)) && validateDateFormat(value))) {
    return 'date';
  }
  else if (!isNaN(value) && typeof value === 'number') {
    return 'number';
  }
  else {
    return typeof value;
  };
};

function formatDate(date) {
  {/* Returns '-' if 'date' is not a valid date string */ }
  if (!moment(date, moment.ISO_8601).isValid()) {
    return '-';
  };
  return moment(date).format('DD-MM-yyyy');
};

function exportToExcel(json, fileName) {
  if (!Array.isArray(json) || json.length === 0) {
    console.error("Export failed: Provided data is not a valid array.", json);
    Modal.error({ title: "No valid data to export." });
    return;
  }

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const workSheet = XLSX.utils.json_to_sheet(json);

  const columnWidths = json.length
    ? Object.keys(json[0]).map((key) => ({
      wch: Math.max(10, key.length + 5),
    }))
    : [];

  workSheet["!cols"] = columnWidths;

  const workBook = { Sheets: { data: workSheet }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(workBook, { bookType: "xlsx", type: "array" });

  const data = new Blob([excelBuffer], { type: fileType });
  fileSaver.saveAs(
    data,
    `${fileName}_${moment(new Date()).format(
      "YYYY-MM-DD_hh-mm A"
    )}${fileExtension}`
  );
}
const formatIndian = (val) => {
  if (val >= 1000000000) return (val / 1000000000).toFixed(2) + " Ar"; // Arab
  if (val >= 10000000) return (val / 10000000).toFixed(2) + " Cr";     // Crore
  if (val >= 100000) return (val / 100000).toFixed(2) + " L";          // Lakh
  if (val >= 1000) return (val / 1000).toFixed(2) + " K";              // Thousand
  return val.toLocaleString();
};
export {
  uniqueValues,
  advanceFilterUniqueValues,
  uniqueValuesWithoutAllOption,
  uniqueValuesWithoutOption,
  exportToExcel,
  formatDate,
  getDataType,
  validateDateFormat,
  formatIndian
};
